export const toFcpMetric = (metric) => {
    const { value } = metric;
    return {
        fcp: Math.trunc(value),
        metadata: {},
    };
};
//# sourceMappingURL=fcp.js.map